require('./style.less');

var Marionette = require('marionette');

require('raphael');
require('autosize');
require('extendJQuery'); //(unselectable)

require('jquery-ui-draggable');
require('../../../../../../../plugin/vendor/bundle/jquery-ui-resizable/bundle');


module.exports = Marionette.ItemView.extend({
    className: 'text-area-shape-wr',
    template: require('./template.hbs'),

    initialize: function() {

        var ch = this.options.channel;

        this.listenTo(ch, 'textAreaView.scaleWithPaper',        this.scaleWithPaper);
        this.listenTo(ch, 'textAreaView.updateColor',           this._updateColor );

    },
    ui: {
        header:     '.ta-shape-header',
        textarea:   '.text-area-shape-ta',
        okBtn:      '.ta-btn-ok',
        cancelBtn:  '.ta-btn-cancel'
    },
    onRender: function() {

        var o = this.options;
        this.ui.header.unselectable();

        //put in DOM first for measurements
        this.$el.appendTo( o.canvasView.$el );

        // https://github.com/jackmoore/autosize/issues/336 -- perhaps update (the jquery one had an extra line)
        // setting rows to 1 doesn't fix in this version
        // will set size -- do b/f other size calcs or will be off
        this._setupAutosizePlugin();

        var headerHt = this.ui.header.outerHeight();

        /* position in bounds on first click -- not doing on rescale for now -- prob more performant way to handle */
        var mouseX = o.x,
            mouseY = o.y,
            elW = this.$el.outerWidth(),
            elH = this.$el.outerHeight(),
            mouseLeftBound = mouseX + elW,
            mouseBottomBound = mouseY + elH,
            canvasLeftBound = o.canvasView.$el.outerWidth(),
            canvasBottomBound = o.canvasView.$el.outerHeight(),
            px = mouseLeftBound > canvasLeftBound
                    ? canvasLeftBound - elW
                    : mouseX,
            py = mouseBottomBound > canvasBottomBound
                    ? canvasBottomBound - elH
                    : mouseY;

        this._position(px, py);

        this.ui.textarea
            .css({ color: o.color})
            .focus();

        this.$el.draggable({
            containment: o.canvasView.$el,
            scroll: false, // something funky so turn off ... maybe need diff container ... plus other shapes don't scroll
            addClasses: false, // working, though  prob don't need -- 'dragging class still applied
            handle: this.ui.header
        })
        .resizable({
            containment: o.canvasView.$el,
            minWidth: 140, //fix to stop header from collapsing ...
            // ... maybe don't want resizable, esp combo with autosize on the textarea -- at least one line ... wait for feedback b/f finalizing ...
            minHeight: this.$el.outerHeight(), // don't allow it smaller than the original size
            // helper: "ui-resizable-helper", -- resize event still called with this
           // ghost: true, resize still called ... eh
            resize: _.bind(function(e, ui) {
                var size = ui.size;
                this.ui.textarea.css({
                    height: size.height - headerHt,
                    width: size.width
                });
            }, this),
            start: _.bind(function() {
                //alternative would be to not use the resize callback but to use a 'helper' or a 'ghost'
                this.ui.textarea.trigger('autosize.destroy');
            }, this),
            stop: _.bind(function() {
                this._setupAutosizePlugin(); //maybe better to use the update here (if use ghost/helper) ...
            }, this)
            //maybe only allow horizontal???
        });
        // could also have better styles for resizable corners ... wait for feedback ...
        return this;
    },
    _setupAutosizePlugin: function() {
        this.ui.textarea.autosize({
            callback: _.bind(this.resizeFromTextAreaResize, this)
        });
    },
    events: {
        'mousedown': function(e) {
            //allow clicking on the text area
            e.stopPropagation();
        },
        'click @ui.okBtn': function() {
            this.options.onOk( this.getText() );
        },
        'click @ui.cancelBtn': function() {
            this.options.onCancel();
        }
    },
    replaceWithTextPath: function() {

        var $ta = this.ui.textarea,
            paper = this.options.paper,
            elPos = this.$el.position(),
            taPos = this.ui.textarea.position(),
            x = elPos.left + taPos.left + parseFloat( this.ui.textarea.css('padding-left') ), //currently no border
            y = elPos.top + taPos.top + parseFloat( this.ui.textarea.css('padding-top') ), //currently no border
            fontSize = parseFloat( $ta.css('font-size') ) ,
            fontFamily = $ta.css('font-family'), //ARIAL -- now defined in css; must be the same as the cufon font
            txt = this.getText(),
            $fvWr = this.options.channel.request('viewerContainer'), //could mediate better (or pass in)
            wrappedText = $.fn.textWrap( txt, $ta.width(), fontSize, fontFamily, $fvWr ); //currently not worrying about padding ...

        this.$el.css('visibility', 'hidden');  //create box first  -- out for debug -- still needed? could just remove ...
        //this.$el.css('opacity', 0.3); //for test positioning of the raphael path

        //long paths will be very non-performant -- would lend case to using text, not the path, if can do that ...
        //TODO: get default attr's from page XREF (defaultSVGAttrsEdit)
        //Paper.print aligns with the baseline of the first line -- this is different that paper.text (wouldn't need the adjustment)
        var textShape = paper.print( x, y + fontSize , wrappedText, paper.getFont(fontFamily), fontSize, 'baseline')
            .attr({
                //'text-anchor': 'start', //middle by default -- N/A for path -- see origin param above
                'font-family': fontFamily,
                'font-size': fontSize,
                stroke: 'transparent',
                'stroke-opacity': 0.01,
                fill: $ta.css('color')
        });

        //remove $ta?
        return textShape;
    },
    getText: function() {
        return this.ui.textarea.val();
    },
    resizeFromTextAreaResize: function() {
        var headerHt = this.ui.header.outerHeight(),
            taHeight = this.ui.textarea.outerHeight();
        this.$el.css('height', headerHt + taHeight);
    },
    // not scaling: just repositioning
    scaleWithPaper: function(curScale, prevScale) {
        var C = curScale / prevScale,
            pos = this.$el.position();
        this._position( pos.left * C, pos.top * C );
    },
    _position: function(x, y) {
        this.$el.css({ left: x, top: y });
    },

    _updateColor: function( color ) {
        this.ui.textarea.css({ color: color });
    },
    onBeforeDestroy: function() {
        this.ui.textarea.trigger('autosize.destroy');
        this.$el
            .draggable('destroy')
            .resizable('destroy');
    },
    destroy: function() {
        Marionette.ItemView.prototype.destroy.apply(this, arguments);
        /* ensure clear of jq cache */
        this.$('*').remove();
        this.$el.remove();
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/graphic/text/textAreaShape/textAreaShape.js
 ** module id = 364
 ** module chunks = 0
 **/